__turbopack_context__.v({
  "accordionIconRoundedWrap": "Header-module-scss-module__ZlUnMG__accordionIconRoundedWrap",
  "active": "Header-module-scss-module__ZlUnMG__active",
  "btnMark": "Header-module-scss-module__ZlUnMG__btnMark",
  "burgerActive": "Header-module-scss-module__ZlUnMG__burgerActive",
  "fadeInOut": "Header-module-scss-module__ZlUnMG__fadeInOut",
  "mobileMenuBgActive": "Header-module-scss-module__ZlUnMG__mobileMenuBgActive",
  "mobileNavBgFill": "Header-module-scss-module__ZlUnMG__mobileNavBgFill",
  "mobileNavBgFillActive": "Header-module-scss-module__ZlUnMG__mobileNavBgFillActive",
  "navbar": "Header-module-scss-module__ZlUnMG__navbar",
  "navbarBgDark": "Header-module-scss-module__ZlUnMG__navbarBgDark",
  "navbarDropdownClinicLink": "Header-module-scss-module__ZlUnMG__navbarDropdownClinicLink",
  "navbarDropdownIcon": "Header-module-scss-module__ZlUnMG__navbarDropdownIcon",
  "navbarLink": "Header-module-scss-module__ZlUnMG__navbarLink",
  "navbarLinkCover": "Header-module-scss-module__ZlUnMG__navbarLinkCover",
  "navigation": "Header-module-scss-module__ZlUnMG__navigation",
  "navigationOpened": "Header-module-scss-module__ZlUnMG__navigationOpened",
  "wrapper": "Header-module-scss-module__ZlUnMG__wrapper",
});
